var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadGray(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.407,
    height: 19.175,
    viewBox: "0 0 19.407 19.175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Upload_1157132",
    transform: "translate(19.407 19.175) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2760",
    "data-name": "Path 2760",
    d: "M18.424,10.677H.963A.943.943,0,0,1,0,9.754V.923A.943.943,0,0,1,.963,0a.93.93,0,0,1,.963.923V8.851H17.481V.923A.943.943,0,0,1,18.444,0a.93.93,0,0,1,.963.923V9.754A1,1,0,0,1,18.424,10.677Z",
    transform: "translate(19.407 10.677) rotate(180)",
    fill: "#3e2d2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2761",
    "data-name": "Path 2761",
    d: "M9.091,3.984,5.379.271a.97.97,0,0,0-1.345,0L.281,3.984A.956.956,0,0,0,0,4.666a.91.91,0,0,0,.281.662.944.944,0,0,0,.662.281.956.956,0,0,0,.682-.281L3.673,3.3v9.533a1,1,0,0,0,2.007,0V3.261L7.747,5.328a.97.97,0,0,0,1.345,0,.944.944,0,0,0,.281-.662A.956.956,0,0,0,9.091,3.984Z",
    transform: "translate(14.388 19.175) rotate(180)",
    fill: "#3e2d2e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadGray);
export default __webpack_public_path__ + "static/media/upload-gray.331a6cfc32e2fa5321ccef340e1fedc0.svg";
export { ForwardRef as ReactComponent };